/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Filesopentitle2Inputs */

const en_filesopentitle2 = /** @type {(inputs: Filesopentitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Open this file in a new tab`)
};

const pt_filesopentitle2 = /** @type {(inputs: Filesopentitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abrir o ficheiro num separador novo`)
};

/**
* | output |
* | --- |
* | "Open this file in a new tab" |
*
* @param {Filesopentitle2Inputs} inputs
* @param {{ locale?: "en" | "pt" }} options
* @returns {LocalizedString}
*/
const filesopentitle2 = /** @type {((inputs?: Filesopentitle2Inputs, options?: { locale?: "en" | "pt" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Filesopentitle2Inputs, { locale?: "en" | "pt" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_filesopentitle2(inputs)
	return pt_filesopentitle2(inputs)
});
export { filesopentitle2 as "filesOpenTitle" }